// src/pages/Moderation/ChannelsViolationsPage/ui/ChannelsViolationsTable/ChannelsViolationsTable.tsx
import React from 'react';
import './ChannelsViolationsTable.scss';

import { GetFlagsResponse } from 'redux/reducers/moderation/types';
import { Pagination } from 'ui/NewPagination/Pagination';
import { NotFound } from 'ui/NotFound/NotFound';
import { ModerationChannel } from '../model/types';
import { ChannelsViolationsHeader } from './ChannelsViolationsHeader';
import { ChannelsViolationsRow } from './ChannelsViolationsRow';

type Props = {
  channels: ModerationChannel[];
  total: number;
  page: number;
  perPage: number;
  onRowClick?: (c: ModerationChannel) => void;
  onPageChange: (p: number) => void;
  onPerPageChange?: (pp: number) => void;
  flags: GetFlagsResponse | null;
};

export const ChannelsViolationsTable: React.FC<Props> = ({
  channels,
  total,
  page,
  perPage,
  onRowClick,
  onPageChange,
  flags,
}) => {
  return (
    <div className="cv-table">
      <ChannelsViolationsHeader />

      {channels.length ? (
        channels.map((c) => (
          <ChannelsViolationsRow
            flags={flags}
            key={c.id}
            channel={c}
            onClick={() => onRowClick?.(c)}
          />
        ))
      ) : (
        <div style={{ padding: 14 }}>
          <NotFound name="Channels" />
        </div>
      )}

      {total > perPage ? (
        <div className="cv-table__footer">
          <Pagination
            page={page}
            total={total}
            perPage={perPage}
            onChange={onPageChange}
            siblingCount={1}
            boundaryCount={1}
          />
        </div>
      ) : null}
    </div>
  );
};
